import { ReactComponent as GeneralTimeline } from 'Assets/Knockathons/Timeline Dark.svg'

const Timeline = () => {
  return <GeneralTimeline className='rounded-2xl overflow-hidden' />
}

export default Timeline
